import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';
import DropDownList from '../dropdown-list/index';
import SearchBox from '../search-box/index';
import '../../styles/core.scss';
import css from './index.scss';
import Button from '../button/index';
import * as ButtonVariants from '../button/variants';
import messages from './messages';

const findSelected = item => item.selected;

const ClassFilter = ({ teachers, yearGroups, searchTerm = '', handleFilterOnChange, handleFilterOnClear, handleOnSearch, intl }) => {
    const selectedTeachers = teachers.find(findSelected);
    const selectedYearGroup = yearGroups.find(findSelected);

    const cloneTeachers = cloneDeep(teachers);
    delete cloneTeachers['0'];

    const cloneYearGroups = cloneDeep(yearGroups);
    delete cloneYearGroups['0'];

    return (
        <div className={css.filterContainer}>
            <div className={css.filterContainer}>
                <div className={css.filters}>
                    <div className={css.teachers}>
                        <DropDownList
                            name="teachers"
                            onChange={handleFilterOnChange}
                            options={cloneTeachers}
                            placeholder={intl.formatMessage(messages.allTeachers)}
                            value={selectedTeachers.key} /></div>
                    <div className={css.year}>
                        <DropDownList
                            name="yearGroups"
                            onChange={handleFilterOnChange}
                            options={cloneYearGroups}
                            placeholder={intl.formatMessage(messages.allYears)}
                            value={selectedYearGroup.key} /></div>
                    <Button
                        containerClassName={css.clear}
                        disabled={false}
                        handleOnClick={handleFilterOnClear}
                        label={intl.formatMessage(messages.clear)}
                        variant={ButtonVariants.LIGHT} />
                    <div className={css.classSearchContainer}>
                        <SearchBox handleOnSearchClick={handleOnSearch} searchTerm={searchTerm} /></div>
                </div>
            </div>
        </div>
    );
};

ClassFilter.propTypes = {
    teachers: PropTypes.array,
    yearGroups: PropTypes.array,
    searchTerm: PropTypes.string,
    handleFilterOnChange: PropTypes.func,
    handleFilterOnClear: PropTypes.func,
    handleOnSearch: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(ClassFilter));



// WEBPACK FOOTER //
// ./app/components/class-filter/index.js